import React from 'react';
import { Flex, Text, Link, Separator, Box, Container } from '@magicpatterns/cubed';
export function Footer() {
  return <Box className="w-full border-t border-border bg-background mt-8" data-id="element-27">
      <Container size="3" data-id="element-28">
        <Flex direction="column" gap="4" py="6" px="4" align="center" className="text-center" data-id="element-29">
          <Flex align="center" gap="3" data-id="element-30">
            <img src="https://cdn.magicpatterns.com/uploads/qcbzuL2uSFvgdkx61PWqEY/logo-gradient-dark.png" alt="Magic Patterns" className="h-5" data-id="element-31" />
          </Flex>
          <Text size="3" color="gray" data-id="element-32">
            Questions about security or compliance? Reach out anytime.
          </Text>
          <Link href="mailto:security@magicpatterns.com" underline="hover" size="3" data-id="element-33">
            security@magicpatterns.com
          </Link>
          <Separator size="4" data-id="element-34" />
          <Text size="1" color="gray" data-id="element-35">
            © {new Date().getFullYear()} Magic Patterns. All rights reserved.
          </Text>
        </Flex>
      </Container>
    </Box>;
}